/**
 * FoodPulse brand slogans.
 *
 * Five one-liners that capture the platform's positioning — used
 * across section heroes (Home, About, Businesses, Deals, Encyclopedia)
 * so every landing page has a consistent, on-brand kicker.
 */

export const FP_SLOGANS = {
  connect_world:  "Connecting the World Through Food",
  discover_save:  "Discover Food. Save Money. Reduce Waste.",
  farm_to_table:  "From Farm to Table, Connected in Real Time.",
  every_food:     "Every Food. Every Deal. Every Community.",
  living_network: "The World's Living Food Network.",
};

// Suggested slogan per major FoodPulse surface. `farm_to_table` is the
// tentpole line — used on Home + as a fallback anywhere else.
export const FP_SLOGAN_BY_SURFACE = {
  home:         "farm_to_table",
  about:        "connect_world",
  businesses:   "discover_save",
  deals:        "every_food",
  encyclopedia: "living_network",
  recipes:      "farm_to_table",
  health:       "connect_world",
  articles:     "living_network",
};

export function foodPulseSlogan(surface, fallback = "farm_to_table") {
  const key = FP_SLOGAN_BY_SURFACE[surface] || fallback;
  return FP_SLOGANS[key] || FP_SLOGANS[fallback];
}
